var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card__content" },
        [
          _c("vue-good-table", {
            attrs: {
              columns: [
                {
                  label: "Fecha",
                  field: "fecha_evento",
                  filterable: true
                },
                {
                  label: "Usuario",
                  field: "usuario.nombre",
                  filterable: true
                },
                {
                  label: "Evento",
                  field: "descripcion_evento",
                  filterable: false
                }
              ],
              "pagination-options": {
                enabled: true,
                perPage: 10,
                nextLabel: "siguiente",
                prevLabel: "anterior",
                rowsPerPageLabel: "Registros por página",
                ofLabel: "de",
                allLabel: "Todo"
              },
              rows: _vm.auditorias,
              "search-options": {
                enabled: true,
                placeholder: "Buscar..."
              },
              styleClass: "vgt-table"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Auditorías")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3322bda6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3322bda6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Auditorias.vue
// module id = 586
// module chunks = 0